// extracted by mini-css-extract-plugin
export default {"btnContent":"TabButtons_btnContent__UTZrl"};